import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { BaseButtonSize } from '../../../shared/components/button/base-button.component';
import { getLastChildRoute } from '../../../shared/helpers/base-get-last-route-child';
import { BaseLoginAsAnotherUserService } from '../../../core/services/base-login-as-another-user.service';
import { TabWithPermissionsInterface } from '../../../shared/interfaces/base-tab-with-permissions.interface';
import { BaseApplicationSectionsInterface } from '../../../shared/interfaces/base-application-sections.interface';

@Component({
  selector: 'base-wrapper',
  templateUrl: './base-wrapper.component.html',
})
export class BaseWrapperComponent implements OnDestroy, OnInit {
  @Input() logo: string;
  @Input() logoSmall: string;
  @Input() applicationSections: BaseApplicationSectionsInterface[] = [];
  @Input() userMenu: TabWithPermissionsInterface[] = [];
  buttonSize = BaseButtonSize.lg;
  isFullscreen = false;
  private destroy$ = new Subject();

  constructor(
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private baseLoginAsAnotherUserService: BaseLoginAsAnotherUserService
  ) {
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationEnd),
        map(() => getLastChildRoute(this.activatedRoute).snapshot.data)
      )
      .subscribe((routeSnapshotData) => {
        this.isFullscreen = !!(routeSnapshotData.isFullscreen && routeSnapshotData.isFullscreen);
      });
  }

  ngOnInit() {
    this.baseLoginAsAnotherUserService.loginAsAnotherUserIfPossible();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
